
import type {FillLayer, LineLayer} from 'react-map-gl';


export const countiesLayer: FillLayer = {
  id: 'countries',
  type: 'fill',
  'source-layer': 'original',
  paint: {
    'fill-outline-color': 'rgba(0,200,0,0.1)',
    'fill-color': 'rgba(0,0,0,0.1)'
  }
};

// Highlighted county polygons
export const highlightLayer: FillLayer = {
  id: 'counties-highlighted',
  type: 'fill',
  source: 'counties',
  'source-layer': 'original',
  paint: {
    'fill-outline-color': '#484896',
    'fill-color': '#6e599f',
    'fill-opacity': 0.75
  }
};

export const europeLayer: FillLayer = {
  id: 'my-data',
  type: 'fill',
  paint: {
    'fill-color': '#002249',
  }
};

export const highlightEuropeLayer: FillLayer = {
  id: 'europe-highlight',
  type: 'fill',
  source: '123',
  paint: {
    'fill-color': '#002249',
  },

};

export const highlightEuropeLayer2: LineLayer = {
  id: 'europe-highlight2',
  type: 'line',
  source: '123',
  paint: {
    "line-opacity": 0.7,
    'line-width': 1,
    'line-color':'rgba(255,255,255,0.4)',
  },
};

export const highlightEuropeLayer2Mobile: LineLayer = {
  id: 'europe-highlight2',
  type: 'line',
  source: '123',
  paint: {
    'line-width': 1,
    'line-color':'rgba(255,255,255,1)',
  },
};

export const continentLayer: FillLayer = {
  id: 'my-data3',
  type: 'fill',
  paint: {
    'fill-color': '#002249',
  }
};

export const highlightContinentLayer: FillLayer = {
  id: 'europe-highlight',
  type: 'fill',
  source: '321',
  paint: {
    'fill-color': '#002249',
  },
};

export const highlightContinentLayer2: LineLayer = {
  id: 'europe-highlight2',
  type: 'line',
  source: '321',
  paint: {
    'line-width': 2,
    'line-color':'rgba(255,255,255,0.4)',

  },
};

export const highlightContinentLayer2Mobile: LineLayer = {
  id: 'europe-highlight2',
  type: 'line',
  source: '321',
  paint: {
    'line-width': 1,
    'line-color':'rgba(255,255,255,1)',

  },
};

export const highlightContinentLayer3: FillLayer  = {
  id: 'europe-highlight',
  type: 'fill',
  source: '321',
  paint: {
    'fill-color': '#00B8F5',
  },
};
